import { createComponents, NO_PATTERN_BUSINESS_LOGIC, } from '@vfde-brix/ws10/core';
import { HEADLINE_BASE_CLASSNAME } from './Constants';
import { createHeadline } from './Headline';
createComponents(".".concat(HEADLINE_BASE_CLASSNAME), createHeadline, NO_PATTERN_BUSINESS_LOGIC);
